import { connect } from 'react-redux';

import { tagFilterUpdate, searchTextUpdate } from '../actions';
import FilterTagBar from '../../../components/FilterTagBar';

const mapStateToProps = ({ data, scene }, ownProps) => {
  return {
    ...ownProps,
    tagsSelected: scene.main.filterTags,
    tagOptions: data.tags,
    placeholder: "Filter by tag or title",
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleTagFilterUpdated: (tags) => { dispatch(tagFilterUpdate(tags)) },
  handleSearchTextUpdated: (text) => { dispatch(searchTextUpdate(text)) }
});

const FilterByTagsBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterTagBar);
export default FilterByTagsBar;



// WEBPACK FOOTER //
// ./src/scenes/Main/components/FilterByTagsBar.js